













































































































































































import {Component, Vue} from "vue-property-decorator";
import {LicenseAPI} from "../api/LicenseAPI";
import {Meta} from "../decorators";

// tslint:disable-next-line
const data = require("../licenses.json");


@Component
@Meta({
    title: "Licencias"
})
export default class Licenses extends Vue {
    baseUrl: string | undefined;

    backend: any[];
    frontend: any[];
    other: any[];
    tabModel: number;


    constructor() {
        super();
        this.tabModel = 0;
        this.baseUrl = process.env.BASE_URL;
        this.backend = [];
        this.frontend = data as any;
        this.other = [{
            name: "lukaszadam Free Illustrations",
            author: "Lukasz Dzikowski",
            url: "https://lukaszadam.com/illustrations",
            license: "MIT License"
        }, {
            name: "github-corners",
            author: "Tim Holman",
            url: "https://github.com/tholman/github-corners/",
            license: "MIT License"
        }];
    }

    mounted() {
        LicenseAPI.get().then(response => {
            this.backend = response.dependencies;
        });
    }

}
